import { useState, useRef, useEffect } from "react";
import "./ytd.css";
import { Helmet } from "react-helmet-async";

export default function YouTubeThumbnailDownloaderPage() {
  const [videoUrl, setVideoUrl] = useState("");
  const [videoId, setVideoId] = useState(null);
  const [thumbnailUrl, setThumbnailUrl] = useState(null);


  const extractVideoId = (url) => {
    try {
      const videoRegex =
        /(?:youtube\.com\/(?:.*[?&]v=|embed\/|shorts\/)|youtu\.be\/)([0-9A-Za-z_-]{11})/;
      const match = url.match(videoRegex);
      return match ? match[1] : null;
    } catch (error) {
      console.error("Error extracting video ID:", error);
      return null;
    }
  };
  
  // Create a reference for the input field
  const searchInputRef = useRef(null);
  

   // Check if the user is on a mobile device
   const isMobile = /Mobi|Android/i.test(window.navigator.userAgent);

   useEffect(() => {
     // Only focus the input field automatically if not on a mobile device
     if (!isMobile && searchInputRef.current) {
       searchInputRef.current.focus();
     }
   }, [isMobile]);

  // Effect to update the thumbnail URL whenever videoId changes
  useEffect(() => {
    if (videoId) {
      const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
      setThumbnailUrl(thumbnailUrl);
    }
  }, [videoId]);

  // Effect to extract video ID when the URL changes
  useEffect(() => {
    const id = extractVideoId(videoUrl);
    setVideoId(id);
  }, [videoUrl]);
  const downloadImage = async () => {
    try {
      if (videoId) {
        // Construct the backend API URL
        const downloadUrl = `https://react-backend-22zh.onrender.com/analysis/download-thumbnail?videoId=${videoId}`;
  
        // Fetch the image from the backend
        const response = await fetch(downloadUrl);
  
        if (!response.ok) {
          throw new Error("Failed to fetch image");
        }
  
        // Convert response to a blob (binary data)
        const blob = await response.blob();
  
        // Create a URL for the blob data
        const blobUrl = window.URL.createObjectURL(blob);
  
        // Create an anchor element and trigger the download
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = `thumbnail-${videoId}.jpg`; // File name for download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
  
        // Revoke the URL to free memory
        window.URL.revokeObjectURL(blobUrl);
      } else {
        alert("Thumbnail not available. Please enter a valid YouTube URL.");
      }
    } catch (error) {
      console.error("Download failed:", error);
    }
  };  

  return (
    <div className="page-container" style={{ textAlign: 'center', padding: '20px' }}>
      <Helmet>
        <title>Download YouTube Thumbnails - Comment Insight</title>
        <meta name="description" content="Download high-quality YouTube thumbnails in full HD. Fast, free, and no sign-up required!" />
        <meta name="keywords" content="YouTube thumbnail downloader, HD thumbnails, thumbnail download" />
        <meta name="google-site-verification" content="hQ_Ds8Z-54QfsMhj-3Kt31lLNWLcOnu_NwYgmZ5-nN0" />
      </Helmet>
      <h1 className="header">YouTube Thumbnail Downloader</h1>
      <p 
        className="no-margin" 
        onClick={() => window.location.href = "/"} 
        style={{ cursor: "pointer", color: "#ffffff" }}
      >
        Made with ❤️ by CommentInsight
      </p>
        
      <div className="search-bar">
         
              <input
                type="text"
                placeholder="Paste YouTube video URL here..."
                value={videoUrl}
                onChange={(e) => setVideoUrl(e.target.value)}
                className="input"
                ref={searchInputRef}
              />
              <button onClick={() => setVideoId(extractVideoId(videoUrl))} className="analyze-btn">✧ Search</button>
            </div>

      {thumbnailUrl && (
        <div className="thumbnails-container" style={{ marginTop: '20px' }}>
          <div className="thumbnail-card">
            <div className="thumbnail-card-content">
              <button
                onClick={downloadImage}
                className="improve-btn"
    
              >
                Download Below Thumbnail
              </button>
              <h2>HD Quality Resolution (1280x720 ~ 300KB)</h2>
              
              <img src={thumbnailUrl} alt="YouTube Thumbnail - HD" className="thumbnail-img" style={{ maxWidth: '100%', height: 'auto' }} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
